import "@fontsource-variable/montserrat";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import ServizioDettaglio from "@/pages/ServizioDettaglio";
import CentraleOperativa from "@/pages/CentraleOperativa";
import DiventaPartner from "@/pages/DiventaPartner";
import Contatti from "@/pages/Contatti";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const Layout = () => (
  <div className="min-h-screen bg-white font-sans text-navy antialiased">
    <SmoothScroll />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <CookieBanner />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="chi-siamo" element={<ChiSiamo />} />
          <Route path="servizi" element={<Servizi />} />
          <Route path="servizi/:slug" element={<ServizioDettaglio />} />
          <Route path="centrale-operativa" element={<CentraleOperativa />} />
          <Route path="diventa-partner" element={<DiventaPartner />} />
          <Route path="contatti" element={<Contatti />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
